import React from 'react';
import { FormHelperText as FormHelperTextNew, FormHelperTextElement } from './FormHelperText';
import { convertOldFormHelperTextProps } from './converter.old';
import type { OldFormHelperTextProps } from './converter.old';

export type FormHelperTextProps = OldFormHelperTextProps;

export const FormHelperText: React.FC<
  FormHelperTextProps & JSX.IntrinsicElements[Extract<FormHelperTextElement, string>]
> = ({ icon, mt, ...props }) => {
  return <FormHelperTextNew {...convertOldFormHelperTextProps({ ...props, icon, mt })} />;
};
